exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-31ea41b3]{\n  display:inline-block;\n  background:red;\n  color:#fff;\n  text-align: center;\n  line-height:24px;\n  width:24px;\n  height:24px;\n  border-radius:50%;\n  margin-left:8px;\n  font-size: 10px;\n}\n", ""]);

// exports
